import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { createPenaltyType } from "../../../../redux/Slices/PenaltyTypesSlice";
import { FaArrowLeft, FaCheck } from "react-icons/fa";

const AddPenaltyType = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const dir = isRTL ? "rtl" : "ltr";
  const textAlign = isRTL ? "right" : "left";

  const [formData, setFormData] = useState({
    name_ar: "",
    name_en: "",
    description: "",
    is_active: true,
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name_ar.trim()) {
      newErrors.name_ar = t("sidenav.hr.penaltyTypesNamespace.nameArRequired");
    }
    if (!formData.name_en.trim()) {
      newErrors.name_en = t("sidenav.hr.penaltyTypesNamespace.nameEnRequired");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const result = await dispatch(createPenaltyType(formData)).unwrap();
      if (result && result.isOffline) {
        localStorage.setItem("offline_add_performed", "true");
        toast.success(
          isRTL
            ? "تم حفظ نوع الجزاء محلياً وسيتم مزامنته عند عودة الاتصال"
            : "Penalty type saved locally and will be synced when online",
        );
      } else {
        toast.success(t("sidenav.hr.penaltyTypesNamespace.createSuccess"));
      }
      navigate("/penalty-types");
    } catch (error) {
      if (error.errors) {
        setErrors(error.errors);
      }
      toast.error(
        error?.message || t("sidenav.hr.penaltyTypesNamespace.errorSaving"),
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
        textAlign,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <button
          onClick={() => navigate("/penalty-types")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px 15px",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            fontFamily:
              '"Times New Roman Bold", "Times New Roman", "Times", serif',
            fontWeight: "bold",
          }}
        >
          {isRTL ? (
            <FaArrowLeft style={{ transform: "rotate(180deg)" }} />
          ) : (
            <FaArrowLeft />
          )}
          {t("btns.back")}
        </button>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "white",
            margin: 0,
            fontFamily:
              '"Times New Roman Bold", "Times New Roman", "Times", serif',
          }}
        >
          {t("sidenav.hr.penaltyTypesNamespace.add")}
        </h1>
      </div>

      <div
        style={{
          backgroundColor: "#1b3350",
          borderRadius: "12px",
          padding: "30px",
          border: "1px solid #333",
          margin: "0",
        }}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                color: "white",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            >
              {t("nameAr")} <span style={{ color: "#f44336" }}>*</span>
            </label>
            <input
              type="text"
              name="name_ar"
              value={formData.name_ar}
              onChange={handleChange}
              placeholder={t("nameAr")}
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#2d3748",
                border: Object.keys(errors).includes("name_ar")
                  ? "1px solid #f44336"
                  : "1px solid #333",
                borderRadius: "4px",
                color: "white",
                fontSize: "14px",
                boxSizing: "border-box",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            />
            {errors.name_ar && (
              <span
                style={{
                  color: "#f44336",
                  fontSize: "12px",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                {errors.name_ar}
              </span>
            )}
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                color: "white",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            >
              {t("nameEn")} <span style={{ color: "#f44336" }}>*</span>
            </label>
            <input
              type="text"
              name="name_en"
              value={formData.name_en}
              onChange={handleChange}
              placeholder={t("nameEn")}
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#2d3748",
                border: Object.keys(errors).includes("name_en")
                  ? "1px solid #f44336"
                  : "1px solid #333",
                borderRadius: "4px",
                color: "white",
                fontSize: "14px",
                boxSizing: "border-box",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            />
            {errors.name_en && (
              <span
                style={{
                  color: "#f44336",
                  fontSize: "12px",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                {errors.name_en}
              </span>
            )}
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                color: "white",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            >
              {t("description")}
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder={t("description")}
              rows="4"
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#2d3748",
                border: "1px solid #333",
                borderRadius: "4px",
                color: "white",
                fontSize: "14px",
                boxSizing: "border-box",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
                resize: "vertical",
              }}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "white",
                fontSize: "14px",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
              }}
            >
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                style={{
                  marginRight: isRTL ? "0" : "10px",
                  marginLeft: isRTL ? "10px" : "0",
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                }}
              />
              {t("active")}
            </label>
          </div>

          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <button
              type="button"
              onClick={() => navigate("/penalty-types")}
              disabled={isSubmitting}
              style={{
                padding: "10px 20px",
                backgroundColor: "#666",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
                fontWeight: "bold",
              }}
            >
              {t("btns.cancel")}
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                padding: "10px 20px",
                backgroundColor: "#AC2000",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                fontFamily:
                  '"Times New Roman Bold", "Times New Roman", "Times", serif',
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {isSubmitting ? (
                t("btns.updating")
              ) : (
                <>
                  <FaCheck />
                  {t("btns.save")}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPenaltyType;
